import { GroupBase, StylesConfig } from "react-select";
import { StylesMergePolicy } from "../types";

export const getStyles = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
>(styles: StylesConfig<Option, IsMulti, Group>, stylesMergePolicy: StylesMergePolicy): StylesConfig<Option, IsMulti, Group> => {
  const extendedStyles = stylesMergePolicy === "merge" ? styles : {} as StylesConfig<Option, IsMulti, Group>;
  const overriddenStyles = stylesMergePolicy === "override" ? styles : {} as StylesConfig<Option, IsMulti, Group>;

  return {
    ...extendedStyles,
    control(base, props) {
      const newBase = {
        ...base,
        borderColor: undefined,
        borderRadius: undefined,
        borderStyle: undefined,
        borderWidth: undefined,
        border: undefined,
        boxShadow: undefined,
        backgroundColor: undefined,
        minHeight: undefined,
        transition: undefined,
        boxSizing: undefined,
        position: undefined,
      };

      return {
        ...newBase,
        ...extendedStyles.control?.(newBase, props),
      };
    },
    valueContainer(base, props) {
      const newBase = {
        ...base,
        padding: undefined,
        gap: "var(--spacing-sm)"
      };

      return {
        ...newBase,
        ...extendedStyles.valueContainer?.(newBase, props),
      };
    },
    dropdownIndicator(base, props) {
      const newBase = {
        ...base,
        padding: undefined,
        transition: undefined,
        color: undefined
      };

      return {
        ...newBase,
        ...extendedStyles.dropdownIndicator?.(newBase, props),
      };
    },
    clearIndicator(base, props) {
      const newBase = {
        ...base,
        padding: undefined,
        transition: undefined,
        color: undefined
      };

      return {
        ...newBase,
        ...extendedStyles.clearIndicator?.(newBase, props),
      };
    },
    input(base, props) {
      const newBase = {
        ...base,
        margin: undefined,
        paddingTop: undefined,
        paddingBottom: undefined,
        color: undefined,
        boxSizing: undefined,
      };

      return {
        ...newBase,
        ...extendedStyles.input?.(newBase, props),
      };
    },
    placeholder(base, props) {
      const newBase = {
        ...base,
        marginLeft: undefined,
        marginRight: undefined,
        color: undefined,
        boxSizing: undefined,
      };

      return {
        ...newBase,
        ...extendedStyles.placeholder?.(newBase, props),
      };
    },
    singleValue(base, props) {
      const newBase = {
        ...base,
        marginLeft: undefined,
        marginRight: undefined,
        color: undefined,
        boxSizing: undefined,
      };

      return {
        ...newBase,
        ...extendedStyles.singleValue?.(newBase, props),
      };
    },
    indicatorsContainer(base, props) {
      const newBase = {
        ...base,
        gap: "var(--spacing-md)",
        marginLeft: "var(--spacing-md)"
      };

      return {
        ...newBase,
        ...extendedStyles.indicatorsContainer?.(newBase, props),
      };
    },
    option: (base, props) => {
      const newBase = {
        ...base,
        ":active": undefined,
        backgroundColor: undefined,
        color: undefined,
        cursor: undefined,
        display: undefined,
        label: undefined,
        option: undefined,
        width: undefined,
        padding: undefined,
      };

      return {
        ...newBase,
        ...extendedStyles.option?.(newBase, props),
      };
    },
    ...overriddenStyles,
  };
};